import React, { PureComponent } from 'react';
import DashboardPage from '../../presenters/ManagedRestroomServices/DashboardPage/DashboardPage';
import * as MRSStatus from '../../../constants/MRSStatus';
import * as api from '../../../services/api';
import LoadingWidget from '../../widgets/LoadingWidget/LoadingWidget';
import { getBranchIds, getBranchRouteNumbers } from '../../../utils/api-util';
import { connect } from 'react-redux';

class Dashboard extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      mrsRequiringActionCount: 0,
      ordersRequiringApproval: null
    };

    this._isMounted = false;
    this.updateState = this.updateState.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    this.updateState();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.appStore.activeBranchId !== prevProps.appStore.activeBranchId
    ) {
      this.updateState();
    }
  }

  updateState() {
    const { activeBranchId, branches, routes } = this.props.appStore;
    const branchIds = getBranchIds(activeBranchId, branches);
    const allowedRoutes = routes.filter((route) =>
      branchIds.includes(route.branchId)
    );

    const branchRouteNumbers = getBranchRouteNumbers(null, allowedRoutes);

    if (branchIds.length > 0 && branchRouteNumbers.length > 0) {
      Promise.all([
        api.mrsOrders.count({
          statuses: [MRSStatus.APPROVAL_REQUIRED.name],
          branchIds,
          branchRouteNumbers
        }),
        api.mrsOrders.get({
          statuses: [MRSStatus.APPROVAL_REQUIRED.name],
          branchIds,
          branchRouteNumbers
        })
      ])
        .then((values) => {
          const [mrsRequiringActionCount, ordersRequiringApproval] = values;

          if (this._isMounted) {
            this.setState({
              loading: false,
              mrsRequiringActionCount: mrsRequiringActionCount.data,
              ordersRequiringApproval: ordersRequiringApproval.data.content
            });
          }
        })
        .catch((error) => {
          this.setState({ loading: false });
        });
    } else {
      this.setState({ loading: false });
    }
  }

  render() {
    return this.state.loading ? (
      <LoadingWidget />
    ) : (
      <DashboardPage
        mrsRequiringActionCount={this.state.mrsRequiringActionCount}
        ordersRequiringApproval={this.state.ordersRequiringApproval}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  appStore: state.get('app').toJS()
});

export default connect(mapStateToProps)(Dashboard);
